import React from "react";
import ChipSelect from "../../../../components/chipSelect";
import FieldLabel from "../../../../components/label";
import { withStyles } from "@mui/styles";
import { useStyles } from "../../indexFormStyles";
import { Box, TextField } from "@mui/material";

function AppointeeMobileDetails({
  classes: { borderBgColorContainer, formGroup },
  errorMessage,
  form,
  handleChange,
  handleChangeChipSelect,
  options,
  validateInputLength,
}) {
  return (
    <Box className={borderBgColorContainer} p={1} mt={2}>
      <Box className={formGroup} pt={0}>
        <FieldLabel label={"Appointee Mobile Available*"} />
        <ChipSelect
          fieldname={"appointee_mobile_available"}
          handleChange={handleChangeChipSelect}
          options={options.availableOrNot}
          selectedItem={form.appointee_mobile_available}
          isMinWidth={true}
        />
      </Box>

      {form.appointee_mobile_available === "Available" && (
        <>
          <Box className={formGroup} pt={0} pb={0}>
            <FieldLabel label={"Mobile same as the Owner of the Policy*"} />
            <ChipSelect
              fieldname={"appointee_mobile_same_as_owner"}
              handleChange={handleChangeChipSelect}
              options={options.sameOrDifferent}
              selectedItem={form.appointee_mobile_same_as_owner}
              isMinWidth={true}
            />
          </Box>

          {form.appointee_mobile_same_as_owner === "Different" && (
            <Box className={formGroup} pt={0} pb={0}>
              <FieldLabel label={"Appointee Mobile*"} />
              <TextField
                id="standard-basic"
                variant="outlined"
                value={form.appointee_mobile}
                name="appointee_mobile"
                onInput={validateInputLength}
                onChange={handleChange}
                autoComplete="off"
                helperText={errorMessage.appointee_mobile}
                fullWidth
              />
            </Box>
          )}
        </>
      )}
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(
  AppointeeMobileDetails
);
